import React from "react";
import ReactDOM from "react-dom";
import App from "./App";
import Modal from "react-modal";
import "./styles/App.scss";

ReactDOM.render(<App />, document.getElementById("root"));
Modal.setAppElement("#root");
